import { print } from 'graphql';
import { PROGRAMS, PROGRAMS_COUNT } from './VistageProgram';
import { PROGRAM_CATEGORIES } from './VistageProgramCategory';
import { PROGRAM_REGIONS } from './VistageProgramRegion';
import {
  PROGRAM_VARIANTS,
  PROGRAM_VARIANT,
  ENTRY_FORM_PROGRAM_VARIANTS,
} from './ProgramVariant';
import {
  EXHIBITION_CATEGORIES,
  EXHIBITION_CATEGORY,
} from './ExhibitionCategory';
import {
  EXHIBITION_SUBCATEGORIES,
  EXHIBITION_SUBCATEGORIES_BY_CATEGORY,
  EXHIBITION_SUBCATEGORY,
} from './ExhibitionSubcategory';
import {
  GET_TOPICS,
  TOPICS_COUNT,
  GET_TOPIC,
  GET_EXHIBITION_CATEGORIES,
  GET_EXHIBITION_SUBCATEGORIES,
  GET_EXHIBITORS,
  TOPIC_PRESENTATION_FILE_DOWNLOAD_URL,
} from './Topic';
import { GROUP_BUDGET_BALANCE } from './GroupBudgetMovement';
import {
  GET_PRESENTATIONS,
  GET_PRESENTATION,
  PRESENTATION_FILE_DOWNLOAD_URL,
  PRESENTATIONS_COUNT,
} from './Presentation';
import {
  USERS,
  AUTH,
  LOGOUT,
  RESET_PASSWORD,
  VERIFY_RECOVERY_PASSWORD_TOKEN,
  USERS_COUNT_BY_ROLE,
  USERS_COUNT,
  USER_HAS_PASSWORD,
  TOKEN_USER_HAS_PASSWORD,
  GET_PROFILE_PICTURE,
  GET_PROFILE_FILE,
  USER_IS_VALIDATED,
  IS_USERNAME_AVAILABLE,
} from './User';
import {
  COMPANY,
  COMPANIES,
  COMPANY_COUNT,
  COMPANY_STATES,
  COMPANY_SOURCES,
  COMPANY_INDUSTRIES,
  INCOMES,
} from './Company';
import { SETTINGS, SETTING_KEY, SETTING_KEY_FOR_ADMIN } from './AppSetting';
import { LANGUAGES } from './Language';
import { ROLE, ROLES } from './Role';
import { PERMISSIONS } from './Permission';
import { ROLE_PERMISSION, ROLE_PERMISSIONS } from './RolePermission';
import { EXPORT_OPERATIONS, OPERATIONS } from './Operation';
import { TAGS } from './Tag';
import { GET_SIGNATURE } from './Signature';
import { IQuery } from '../GraphqlService';
import { ObjectStore } from '../../../enums/EnumsValues';
import {
  GET_TENANT_PICTURE,
  TENANT,
  TENANTS,
  TENANTS_ASSOCIATED_WITH_USER,
  TENANT_COUNT,
  TENANT_FOR_ACCOUNT_BANK_INFORMATION,
  TENANT_HAS_BANK_INFORMATION,
  TENANT_HAS_NECESSARY_INFORMATION,
} from './Tenant';
import { VERIFY_COMPLETE_REGISTER_BY_EMAIL_TOKEN } from './VeryTokens';
import { LOGIN_PROVIDERS } from './LoginProvider';
import { LOGIN_METHODS } from './LoginMethod';
import { SEND_EMAIL, SEND_CONTACT_EMAIL } from './Email';
import { CHECK_INVITATION, INVITATIONS } from './Invitation';
import {
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_LIST,
  USER_HAS_ACCEPTED_TERMS_AND_CONDITIONS,
} from './TermsAndConditions';
import {
  TENANT_SETTING,
  TENANT_SETTINGS,
  TENANT_SETTINGS_COUNT,
} from './TenantSetting';
import { NOTES } from './Note';
import { PLANS } from './Plan';
import { USER_PLANS } from './UserPlan';
import { CATEGORIES } from './Category';
import {
  AVAILABLE_PRODUCT_ACTIONS,
  ESTIMATED_PRODUCT_ORDER_VALUES,
  PRODUCT,
  PRODUCTS,
  PRODUCT_BY_CODE,
  PRODUCT_COUNT,
} from './Product';
import { SUPPLIER, SUPPLIERS, SUPPLIERS_SAFE } from './Supplier';
import { PRODUCT_LOGS, PRODUCT_LOGS_WITH_STOCK } from './ProductLog';
import { STOCK_REASONS } from './StockReason';
import { SHOP, SHOPS, SHOP_COUNT } from './Shop';
import {
  AVAILABLE_ORDER_ACTIONS,
  ESTIMATED_ORDER_VALUES,
  EXPORT_ORDERS,
  ORDER,
  ORDERS,
  ORDERS_IDS,
  ORDER_COUNT,
  ORDER_PAYMENT_STATUS,
} from './Order';
import { ORDER_STATUSES } from './OrderStatus';
import { ORDER_LOG_COUNT, ORDER_LOGS } from './OrderLog';
import {
  EXPORT_WALLET_MOVEMENTS,
  WALLET_MOVEMENT_COUNT,
  WALLET_MOVEMENTS,
} from './WalletMovement';
import { WALLET_REASONS } from './WalletReason';
import { STATS } from './Stats';
import { WALLET_STATS } from './WalletStats';
import { ESTIMATED_PRODUCT_PROFIT } from './EstimatedProductProfit';
import {
  WALLET_REQUEST,
  WALLET_REQUEST_COUNT,
  WALLET_REQUESTS,
} from './WalletRequest';
import { LOG_ACTIONS } from './LogAction';
import { GET_NOTIFICATIONS } from './Notifications';
import { AUDIT_EVENTS, AUDIT_EVENTS_COUNT } from './AuditEvent';
import { PRODUCT_STATUSES } from './ProductStatus';
import { GET_PROVINCES } from './VistageProvince';
import {
  GET_EVENT,
  GET_EVENTS,
  GET_EVENT_BY_PERMALINK,
  EVENTS_COUNT,
} from './VistageEvent';
import { GET_VCG, GET_VCGS } from './Vcg';
import { GET_TAX_CONDITION, GET_TAX_CONDITIONS } from './TaxCondition';
import { GET_EXHIBITOR_FORM_BY_TOKEN } from './ExhibitorFormToken';
import {
  SURVEY_AUDIENCE_SUMMARY,
  SURVEY_CAMPAIGN,
  SURVEY_CAMPAIGN_DISPATCHES,
  SURVEY_CAMPAIGN_DISPATCHES_COUNT,
  SURVEY_CAMPAIGNS,
  SURVEY_CAMPAIGNS_COUNT,
  SURVEY_TYPES,
} from './SurveyCampaign';
import {
  EXTERNAL_PRESENTER_INVOICE_FORM_BY_TOKEN,
  EXTERNAL_PRESENTER_INVOICE_BY_MEETING,
  EXTERNAL_PRESENTER_INVOICE_FILE_LINK,
} from './ExternalPresenterInvoice';
import { USA_PROGRAMS } from './VistageUsaProgram';
import { EXHIBITORS, EXHIBITORS_COUNT, GET_EXHIBITOR_CV_DOWNLOAD_LINK, EXHIBITOR_BANK_DATA, MY_EXHIBITOR_PROFILE, MY_EXHIBITOR_PROFILE_FILE_LINKS } from './Exhibitor';
import {
  GET_EXHIBITOR_REVIEWS,
  GET_EXHIBITOR_REVIEWS_COUNT,
  GET_EXHIBITOR_REVIEW_ELIGIBILITY,
} from './ExhibitorReview';
import { CHAIRS } from './Chair';
import { HITO_TIPOS, HITO_TIPO } from './HitoTipo';
import { HITO_SUBTIPOS, HITO_SUBTIPO } from './HitoSubtipo';
import { MEMBER_HITOS, MEMBER_HITO, MEMBER_HITO_COUNT } from './MemberHito';
import { ZOHO_EMBED_SESSION, ZOHO_EMBED_REPORT_ITEMS } from './ZohoEmbed';
import {
  CONTACTS,
  GET_CONTACT,
  CONTACTS_COUNT,
  EX_MEMBERS_BY_CHAIR,
  CONTACT_COMPANY_DETAILS,
} from './Contact';
import { GET_POSITIONS } from './Position';
import { STAFF_LIST, GET_STAFF, CONTACTS_FOR_STAFF } from './Staff';
import { CONTACT_LOGS, CONTACT_LOG_COUNT } from './ContactLog';
import { GROUP_LOGS, GROUP_LOG_COUNT } from './GroupLog';
import { GROUPS, GET_GROUP, GROUPS_COUNT } from './Group';
import {
  PROSPECTS,
  PROSPECT_COUNT,
  CHAIR_PROSPECT_AVAILABILITY,
} from './Prospect';
import { PROSPECT_REASSIGNMENTS } from './ProspectReassignment';
import { CONTACT_STATUSES } from './ContactStatus';
import {
  ENTRY_FORMS,
  ENTRY_FORMS_COUNT,
  GET_ENTRY_FORM,
  ENTRY_FORM_STATUSES,
  AVAILABLE_ENTRY_FORM_ACTIONS,
  GET_ENTRY_FORM_BY_TOKEN,
  GET_ENTRY_FORM_PDF_URL,
} from './EntryForm';
import { GET_ENTRY_FORM_BY_CONTACT } from './EntryFormByContact';
import { ENTRY_FORM_LOGS, ENTRY_FORM_LOG_COUNT } from './EntryFormLog';
import {
  MEMBERS,
  MEMBERS_COUNT,
  CHECK_MEMBER_CONTACT,
  SEARCH_MEMBER_CONTACTS,
} from './Member';
import {
  BENEFITS,
  BENEFITS_BY_COMPANY_NUMBER,
  APPLICABLE_BENEFITS,
  CALCULATE_BENEFIT_FEES,
} from './Benefit';
import * as MEETING from './Meeting';
import {
  GET_MEETING_EVALUATION_RESULTS,
  GET_EVALUATION_BY_HASH,
  GET_MEETING_EVALUATION_BY_HASH,
} from './Meeting';
import {
  GET_MEETING_GROUPS,
  GET_MEETING_GROUPS_BY_MEETING,
} from './MeetingGroup';
import { REQUEST_REASONS } from './RequestReason';
import { REQUEST_STATUSES } from './RequestStatus';
import {
  REQUESTS,
  REQUEST_COUNT,
  REQUEST,
  GET_REQUEST_PDF_URL,
} from './Request';
import { GROUP_MOVEMENTS, GROUP_MOVEMENT_COUNT } from './GroupMovement';
import { GROUP_BALANCES } from './GroupBalance';
import { LEAVE_POLLS, LEAVE_FORMS } from './LeavePoll';
import { LEAVE_FORM_CALL_ATTEMPTS } from './LeaveFormCallAttempt';
import { GROUP_FILES } from './GroupFile';

let Query = {
  authenticate: { name: 'authenticate', gql: AUTH },
  companies: {
    name: 'companies',
    gql: COMPANIES,
    objectStore: ObjectStore.Company,
  },
  company: { name: 'company', gql: COMPANY },
  companyCount: { name: 'companyCount', gql: COMPANY_COUNT },
  companyStates: { name: 'companyStates', gql: COMPANY_STATES },
  companySources: { name: 'companySources', gql: COMPANY_SOURCES },
  companyIndustries: { name: 'companyIndustries', gql: COMPANY_INDUSTRIES },
  incomes: { name: 'incomes', gql: INCOMES },
  getAppSettingByKey: { name: 'getAppSettingByKey', gql: SETTING_KEY },
  getAppSettings: { name: 'getAppSettings', gql: SETTINGS },
  languages: { name: 'languages', gql: print(LANGUAGES) },
  logout: { name: 'logout', gql: LOGOUT },
  operations: {
    name: 'operations',
    gql: OPERATIONS,
    objectStore: ObjectStore.Operation,
  },
  notes: { name: 'notes', gql: NOTES },
  plans: { name: 'plans', gql: print(PLANS) },
  userPlans: { name: 'userPlans', gql: USER_PLANS },
  permissions: { name: 'permissions', gql: PERMISSIONS },
  resetPassword: { name: 'resetPassword', gql: RESET_PASSWORD },
  role: { name: 'role', gql: ROLE },
  roles: { name: 'roles', gql: ROLES },
  rolePermission: { name: 'rolePermission', gql: ROLE_PERMISSION },
  rolePermissions: { name: 'rolePermissions', gql: ROLE_PERMISSIONS },
  users: { name: 'users', gql: USERS },
  userCount: { name: 'userCount', gql: USERS_COUNT },
  userCountByRole: { name: 'userCountByRole', gql: USERS_COUNT_BY_ROLE },
  userHasPassword: { name: 'userHasPassword', gql: USER_HAS_PASSWORD },
  tokenUserHasPassword: {
    name: 'tokenUserHasPassword',
    gql: TOKEN_USER_HAS_PASSWORD,
  },
  verifyRecoveryPasswordToken: {
    name: 'verifyRecoveryPasswordToken',
    gql: VERIFY_RECOVERY_PASSWORD_TOKEN,
  },
  getProfilePicture: { name: 'getProfilePicture', gql: GET_PROFILE_PICTURE },
  getProfileFile: { name: 'getProfileFile', gql: GET_PROFILE_FILE },
  getSignature: { name: 'getSignature', gql: GET_SIGNATURE },
  tenants: { name: 'tenants', gql: TENANTS },
  tenant: { name: 'tenant', gql: TENANT },
  getTenantPicture: {
    name: 'getTenantPicture',
    gql: GET_TENANT_PICTURE,
  },
  tenantCount: { name: 'tenantCount', gql: TENANT_COUNT },
  exportOperations: { name: 'exportOperations', gql: EXPORT_OPERATIONS },
  verifyCompleteRegisterByEmailToken: {
    name: 'verifyCompleteRegisterByEmailToken',
    gql: VERIFY_COMPLETE_REGISTER_BY_EMAIL_TOKEN,
  },
  tags: { name: 'tags', gql: TAGS, objectStore: ObjectStore.Tag },
  loginProviders: { name: 'loginProviders', gql: LOGIN_PROVIDERS },
  loginMethods: { name: 'loginMethods', gql: LOGIN_METHODS },
  sendEmail: { name: 'sendEmail', gql: SEND_EMAIL },
  sendContactEmail: { name: 'sendContactEmail', gql: SEND_CONTACT_EMAIL },
  termsAndConditions: { name: 'termsAndConditions', gql: TERMS_AND_CONDITIONS },
  userHasAcceptedTermsAndConditions: {
    name: 'userHasAcceptedTermsAndConditions',
    gql: USER_HAS_ACCEPTED_TERMS_AND_CONDITIONS,
  },
  termsAndConditionsList: {
    name: 'termsAndConditionsList',
    gql: TERMS_AND_CONDITIONS_LIST,
  },
  checkInvitation: {
    name: 'checkInvitation',
    gql: CHECK_INVITATION,
  },
  invitations: {
    name: 'invitations',
    gql: INVITATIONS,
  },
  tenantsAssociatedWithUser: {
    name: 'tenantsAssociatedWithUser',
    gql: TENANTS_ASSOCIATED_WITH_USER,
  },
  tenantSettings: {
    name: 'tenantSettings',
    gql: TENANT_SETTINGS,
  },
  tenantSettingsCount: {
    name: 'tenantSettingsCount',
    gql: TENANT_SETTINGS_COUNT,
  },
  tenantSetting: {
    name: 'tenantSetting',
    gql: TENANT_SETTING,
  },
  auditEvents: {
    name: 'auditEvents',
    gql: AUDIT_EVENTS,
  },
  auditEventsCount: {
    name: 'auditEventsCount',
    gql: AUDIT_EVENTS_COUNT,
  },
  getAppSettingByKeyForAdmin: {
    name: 'getAppSettingByKeyForAdmin',
    gql: SETTING_KEY_FOR_ADMIN,
  },
  categories: {
    name: 'categories',
    gql: CATEGORIES,
  },
  products: {
    name: 'products',
    gql: PRODUCTS,
  },
  suppliers: {
    name: 'suppliers',
    gql: SUPPLIERS,
  },
  suppliersSafe: {
    name: 'suppliersSafe',
    gql: SUPPLIERS_SAFE,
  },
  exhibitors: {
    name: 'exhibitors',
    gql: EXHIBITORS,
  },
  exhibitorsCount: {
    name: 'exhibitorsCount',
    gql: EXHIBITORS_COUNT,
  },
  getExhibitorCVDownloadLink: {
    name: 'getExhibitorCVDownloadLink',
    gql: GET_EXHIBITOR_CV_DOWNLOAD_LINK,
  },
  exhibitorBankData: {
    name: 'exhibitorBankData',
    gql: EXHIBITOR_BANK_DATA,
  },
  myExhibitorProfile: { name: 'myExhibitorProfile', gql: MY_EXHIBITOR_PROFILE },
  myExhibitorProfileFileLinks: {
    name: 'myExhibitorProfileFileLinks',
    gql: MY_EXHIBITOR_PROFILE_FILE_LINKS,
  },
  exhibitorReviews: {
    name: 'exhibitorReviews',
    gql: GET_EXHIBITOR_REVIEWS,
  },
  exhibitorReviewsCount: {
    name: 'exhibitorReviewsCount',
    gql: GET_EXHIBITOR_REVIEWS_COUNT,
  },
  exhibitorReviewEligibility: {
    name: 'exhibitorReviewEligibility',
    gql: GET_EXHIBITOR_REVIEW_ELIGIBILITY,
  },
  chairs: {
    name: 'chairs',
    gql: CHAIRS,
  },
  productCount: {
    name: 'productCount',
    gql: PRODUCT_COUNT,
  },
  productLogs: {
    name: 'productLogs',
    gql: PRODUCT_LOGS,
  },
  product: {
    name: 'product',
    gql: PRODUCT,
  },
  productLogsWithStock: {
    name: 'productLogsWithStock',
    gql: PRODUCT_LOGS_WITH_STOCK,
  },
  stockReasons: {
    name: 'stockReasons',
    gql: STOCK_REASONS,
  },
  shops: {
    name: 'shops',
    gql: SHOPS,
  },
  shop: {
    name: 'shop',
    gql: SHOP,
  },
  shopCount: {
    name: 'shopCount',
    gql: SHOP_COUNT,
  },
  userIsValidated: {
    name: 'userIsValidated',
    gql: USER_IS_VALIDATED,
  },
  orderCount: {
    name: 'orderCount',
    gql: ORDER_COUNT,
  },
  orders: {
    name: 'orders',
    gql: ORDERS,
  },
  order: {
    name: 'order',
    gql: ORDER,
  },
  orderStatuses: {
    name: 'orderStatuses',
    gql: ORDER_STATUSES,
  },
  availableOrderActions: {
    name: 'availableOrderActions',
    gql: AVAILABLE_ORDER_ACTIONS,
  },
  orderLogs: {
    name: 'orderLogs',
    gql: ORDER_LOGS,
  },
  tenantForAccountBankInformation: {
    name: 'tenantForAccountBankInformation',
    gql: TENANT_FOR_ACCOUNT_BANK_INFORMATION,
  },
  walletMovements: {
    name: 'walletMovements',
    gql: WALLET_MOVEMENTS,
  },
  walletReasons: {
    name: ' walletReasons',
    gql: WALLET_REASONS,
  },
  tenantHasBankInformation: {
    name: ' tenantHasBankInformation',
    gql: TENANT_HAS_BANK_INFORMATION,
  },
  tenantHasNecessaryInformation: {
    name: ' tenantHasNecessaryInformation',
    gql: TENANT_HAS_NECESSARY_INFORMATION,
  },
  stats: {
    name: 'stats',
    gql: STATS,
  },
  walletStats: {
    name: 'walletStats',
    gql: WALLET_STATS,
  },
  walletMovementCount: {
    name: 'walletMovementCount',
    gql: WALLET_MOVEMENT_COUNT,
  },
  supplier: {
    name: 'supplier',
    gql: SUPPLIER,
  },
  estimatedProductProfit: {
    name: 'estimatedProductProfit',
    gql: ESTIMATED_PRODUCT_PROFIT,
  },
  exportOrders: {
    name: 'exportOrders',
    gql: EXPORT_ORDERS,
  },
  exportWalletMovements: {
    name: 'exportWalletMovements',
    gql: EXPORT_WALLET_MOVEMENTS,
  },
  isUsernameAvailable: {
    name: 'isUsernameAvailable',
    gql: IS_USERNAME_AVAILABLE,
  },
  walletRequest: {
    name: 'walletRequest',
    gql: WALLET_REQUEST,
  },
  walletRequests: {
    name: 'walletRequests',
    gql: WALLET_REQUESTS,
  },
  walletRequestCount: {
    name: 'walletRequestCount',
    gql: WALLET_REQUEST_COUNT,
  },
  logActions: {
    name: 'logActions',
    gql: LOG_ACTIONS,
  },
  orderLogCount: {
    name: 'orderLogCount',
    gql: ORDER_LOG_COUNT,
  },
  orderPaymentStatus: {
    name: 'orderPaymentStatus',
    gql: ORDER_PAYMENT_STATUS,
  },
  estimatedOrderValues: {
    name: 'estimatedOrderValues',
    gql: ESTIMATED_ORDER_VALUES,
  },
  productByCode: {
    name: 'productByCode',
    gql: PRODUCT_BY_CODE,
  },
  ordersIds: {
    name: 'ordersIds',
    gql: ORDERS_IDS,
  },
  getNotifications: {
    name: 'getNotifications',
    gql: GET_NOTIFICATIONS,
  },
  availableProductActions: {
    name: 'availableProductActions',
    gql: AVAILABLE_PRODUCT_ACTIONS,
  },
  productStatuses: {
    name: 'productStatuses',
    gql: PRODUCT_STATUSES,
  },
  estimatedProductOrderValues: {
    name: 'estimatedProductOrderValues',
    gql: ESTIMATED_PRODUCT_ORDER_VALUES,
  },
  programs: {
    name: 'programs',
    gql: PROGRAMS,
  },
  programsCount: {
    name: 'programsCount',
    gql: PROGRAMS_COUNT,
  },
  programCategories: {
    name: 'programCategories',
    gql: PROGRAM_CATEGORIES,
  },
  programRegions: {
    name: 'programRegions',
    gql: PROGRAM_REGIONS,
  },
  programVariants: {
    name: 'programVariants',
    gql: PROGRAM_VARIANTS,
  },
  programVariant: {
    name: 'programVariant',
    gql: PROGRAM_VARIANT,
  },
  entryFormProgramVariants: {
    name: 'entryFormProgramVariants',
    gql: ENTRY_FORM_PROGRAM_VARIANTS,
  },
  getProvinces: {
    name: 'getProvinces',
    gql: GET_PROVINCES,
  },
  getEvent: {
    name: 'getEvent',
    gql: GET_EVENT,
  },
  getEvents: {
    name: 'getEvents',
    gql: GET_EVENTS,
  },
  eventsCount: {
    name: 'eventsCount',
    gql: EVENTS_COUNT,
  },
  getEventByPermalink: {
    name: 'getEventByPermalink',
    gql: GET_EVENT_BY_PERMALINK,
  },
  vcg: {
    name: 'vcg',
    gql: GET_VCG,
  },
  vcgs: {
    name: 'vcgs',
    gql: GET_VCGS,
  },
  totalVcgs: {
    name: 'totalVcgs',
    gql: GET_VCGS,
  },
  usaPrograms: {
    name: 'usaPrograms',
    gql: USA_PROGRAMS,
  },
  exhibitionCategories: {
    name: 'exhibitionCategories',
    gql: EXHIBITION_CATEGORIES,
  },
  exhibitionCategory: {
    name: 'exhibitionCategory',
    gql: EXHIBITION_CATEGORY,
  },
  exhibitionSubcategories: {
    name: 'exhibitionSubcategories',
    gql: EXHIBITION_SUBCATEGORIES,
  },
  exhibitionSubcategoriesByCategory: {
    name: 'exhibitionSubcategoriesByCategory',
    gql: EXHIBITION_SUBCATEGORIES_BY_CATEGORY,
  },
  exhibitionSubcategory: {
    name: 'exhibitionSubcategory',
    gql: EXHIBITION_SUBCATEGORY,
  },
  getExhibitorFormByToken: {
    name: 'getExhibitorFormByToken',
    gql: GET_EXHIBITOR_FORM_BY_TOKEN,
  },
  externalPresenterInvoiceFormByToken: {
    name: 'externalPresenterInvoiceFormByToken',
    gql: EXTERNAL_PRESENTER_INVOICE_FORM_BY_TOKEN,
  },
  externalPresenterInvoiceByMeeting: {
    name: 'externalPresenterInvoiceByMeeting',
    gql: EXTERNAL_PRESENTER_INVOICE_BY_MEETING,
  },
  externalPresenterInvoiceFileLink: {
    name: 'externalPresenterInvoiceFileLink',
    gql: EXTERNAL_PRESENTER_INVOICE_FILE_LINK,
  },
  taxCondition: {
    name: 'taxCondition',
    gql: GET_TAX_CONDITION,
  },
  taxConditions: {
    name: 'taxConditions',
    gql: GET_TAX_CONDITIONS,
  },
  totalTaxConditions: {
    name: 'totalTaxConditions',
    gql: GET_TAX_CONDITIONS,
  },
  hitoTipos: {
    name: 'hitoTipos',
    gql: HITO_TIPOS,
  },
  zohoEmbedSession: {
    name: 'zohoEmbedSession',
    gql: ZOHO_EMBED_SESSION,
  },
  zohoEmbedReportItems: {
    name: 'zohoEmbedReportItems',
    gql: ZOHO_EMBED_REPORT_ITEMS,
  },
  hitoTipo: {
    name: 'hitoTipo',
    gql: HITO_TIPO,
  },
  hitoSubtipos: {
    name: 'hitoSubtipos',
    gql: HITO_SUBTIPOS,
  },
  hitoSubtipo: {
    name: 'hitoSubtipo',
    gql: HITO_SUBTIPO,
  },
  memberHitos: {
    name: 'memberHitos',
    gql: MEMBER_HITOS,
  },
  memberHito: {
    name: 'memberHito',
    gql: MEMBER_HITO,
  },
  memberHitoCount: {
    name: 'memberHitoCount',
    gql: MEMBER_HITO_COUNT,
  },
  contacts: {
    name: 'contacts',
    gql: CONTACTS,
  },
  contactCompanyDetails: {
    name: 'contactCompanyDetails',
    gql: CONTACT_COMPANY_DETAILS,
  },
  getContact: {
    name: 'getContact',
    gql: GET_CONTACT,
  },
  contactsCount: {
    name: 'contactsCount',
    gql: CONTACTS_COUNT,
  },
  exMembersByChair: {
    name: 'exMembersByChair',
    gql: EX_MEMBERS_BY_CHAIR,
  },
  staffList: {
    name: 'getStaffList',
    gql: STAFF_LIST,
  },
  getStaff: {
    name: 'getStaff',
    gql: GET_STAFF,
  },
  contactsForStaff: {
    name: 'contacts',
    gql: CONTACTS_FOR_STAFF,
  },
  contactLogs: {
    name: 'contactLogs',
    gql: CONTACT_LOGS,
  },
  contactLogCount: {
    name: 'contactLogCount',
    gql: CONTACT_LOG_COUNT,
  },
  groupLogs: {
    name: 'groupLogs',
    gql: GROUP_LOGS,
  },
  groupLogCount: {
    name: 'groupLogCount',
    gql: GROUP_LOG_COUNT,
  },
  groups: {
    name: 'groups',
    gql: GROUPS,
  },
  getGroup: {
    name: 'getGroup',
    gql: GET_GROUP,
  },
  groupsCount: {
    name: 'groupsCount',
    gql: GROUPS_COUNT,
  },
  prospects: {
    name: 'prospects',
    gql: PROSPECTS,
  },
  prospectsCount: {
    name: 'prospectsCount',
    gql: PROSPECT_COUNT,
  },
  chairProspectAvailability: {
    name: 'chairProspectAvailability',
    gql: CHAIR_PROSPECT_AVAILABILITY,
  },
  prospectReassignments: {
    name: 'prospectReassignments',
    gql: PROSPECT_REASSIGNMENTS,
  },
  contactStatuses: {
    name: 'contactStatuses',
    gql: CONTACT_STATUSES,
  },
  getPositions: {
    name: 'getPositions',
    gql: GET_POSITIONS,
  },
  entryForms: {
    name: 'entryForms',
    gql: ENTRY_FORMS,
  },
  entryFormsCount: {
    name: 'entryFormsCount',
    gql: ENTRY_FORMS_COUNT,
  },
  getEntryForm: {
    name: 'entryForm',
    gql: GET_ENTRY_FORM,
  },
  entryFormStatuses: {
    name: 'entryFormStatuses',
    gql: ENTRY_FORM_STATUSES,
  },
  availableEntryFormActions: {
    name: 'availableEntryFormActions',
    gql: AVAILABLE_ENTRY_FORM_ACTIONS,
  },
  getEntryFormByToken: {
    name: 'getEntryFormByToken',
    gql: GET_ENTRY_FORM_BY_TOKEN,
  },
  getEntryFormPdfUrl: {
    name: 'getEntryFormPdfUrl',
    gql: GET_ENTRY_FORM_PDF_URL,
  },
  getEntryFormByContact: {
    name: 'getEntryFormByContact',
    gql: GET_ENTRY_FORM_BY_CONTACT,
  },
  entryFormLogs: {
    name: 'entryFormLogs',
    gql: ENTRY_FORM_LOGS,
  },
  entryFormLogCount: {
    name: 'entryFormLogCount',
    gql: ENTRY_FORM_LOG_COUNT,
  },
  members: {
    name: 'members',
    gql: MEMBERS,
  },
  membersCount: {
    name: 'membersCount',
    gql: MEMBERS_COUNT,
  },
  checkMemberContact: {
    name: 'checkMemberContact',
    gql: CHECK_MEMBER_CONTACT,
  },
  searchMemberContacts: {
    name: 'searchMemberContacts',
    gql: SEARCH_MEMBER_CONTACTS,
  },
  benefits: {
    name: 'benefits',
    gql: BENEFITS,
  },
  benefitsByCompanyNumber: {
    name: 'benefitsByCompanyNumber',
    gql: BENEFITS_BY_COMPANY_NUMBER,
  },
  applicableBenefits: {
    name: 'applicableBenefits',
    gql: APPLICABLE_BENEFITS,
  },
  calculateBenefitFees: {
    name: 'calculateBenefitFees',
    gql: CALCULATE_BENEFIT_FEES,
  },
  meeting: {
    name: 'meeting',
    gql: MEETING.GET_MEETING,
  },
  meetings: {
    name: 'meetings',
    gql: MEETING.GET_MEETINGS,
  },
  meetingsCount: {
    name: 'meetingsCount',
    gql: MEETING.GET_MEETINGS_COUNT,
  },
  groupsForMeetings: {
    name: 'groupsForMeetings',
    gql: MEETING.GET_GROUPS_FOR_MEETINGS,
  },
  exhibitorsForMeetings: {
    name: 'exhibitorsForMeetings',
    gql: MEETING.GET_EXHIBITORS_FOR_MEETINGS,
  },
  contactsForMeetings: {
    name: 'contactsForMeetings',
    gql: MEETING.GET_CONTACTS_FOR_MEETINGS,
  },
  activeMembersByGroup: {
    name: 'activeMembersByGroup',
    gql: MEETING.GET_ACTIVE_MEMBERS_BY_GROUP,
  },
  meetingGroups: {
    name: 'meetingGroups',
    gql: GET_MEETING_GROUPS,
  },
  meetingGroupsByMeeting: {
    name: 'meetingGroupsByMeeting',
    gql: GET_MEETING_GROUPS_BY_MEETING,
  },
  getMeetingEvaluationResults: {
    name: 'getMeetingEvaluationResults',
    gql: GET_MEETING_EVALUATION_RESULTS,
  },
  getEvaluationByHash: {
    name: 'getEvaluationByHash',
    gql: GET_EVALUATION_BY_HASH,
  },
  getMeetingEvaluationByHash: {
    name: 'getMeetingEvaluationByHash',
    gql: GET_MEETING_EVALUATION_BY_HASH,
  },
  requestReasons: {
    name: 'requestReasons',
    gql: REQUEST_REASONS,
  },
  requestStatuses: {
    name: 'requestStatuses',
    gql: REQUEST_STATUSES,
  },
  requests: {
    name: 'requests',
    gql: REQUESTS,
  },
  requestCount: {
    name: 'requestCount',
    gql: REQUEST_COUNT,
  },
  request: {
    name: 'request',
    gql: REQUEST,
  },
  getRequestPdfUrl: {
    name: 'getRequestPdfUrl',
    gql: GET_REQUEST_PDF_URL,
  },
  groupMovements: {
    name: 'groupMovements',
    gql: GROUP_MOVEMENTS,
  },
  groupMovementCount: {
    name: 'groupMovementCount',
    gql: GROUP_MOVEMENT_COUNT,
  },
  topics: {
    name: 'topics',
    gql: GET_TOPICS,
  },
  topicsCount: {
    name: 'topicsCount',
    gql: TOPICS_COUNT,
  },
  topic: {
    name: 'topic',
    gql: GET_TOPIC,
  },
  topicExhibitionCategories: {
    name: 'topicExhibitionCategories',
    gql: GET_EXHIBITION_CATEGORIES,
  },
  topicExhibitionSubcategories: {
    name: 'topicExhibitionSubcategories',
    gql: GET_EXHIBITION_SUBCATEGORIES,
  },
  topicExhibitors: {
    name: 'topicExhibitors',
    gql: GET_EXHIBITORS,
  },
  topicPresentationFileDownloadUrl: {
    name: 'topicPresentationFileDownloadUrl',
    gql: TOPIC_PRESENTATION_FILE_DOWNLOAD_URL,
  },
  presentations: {
    name: 'presentations',
    gql: GET_PRESENTATIONS,
  },
  presentationsCount: {
    name: 'presentationsCount',
    gql: PRESENTATIONS_COUNT,
  },
  presentation: {
    name: 'presentation',
    gql: GET_PRESENTATION,
  },
  presentationFileDownloadUrl: {
    name: 'presentationFileDownloadUrl',
    gql: PRESENTATION_FILE_DOWNLOAD_URL,
  },
  groupBudgetBalance: {
    name: 'groupBudgetBalance',
    gql: GROUP_BUDGET_BALANCE,
  },
  groupBalances: {
    name: 'groupBalances',
    gql: GROUP_BALANCES,
  },
  leavePolls: {
    name: 'leavePolls',
    gql: LEAVE_POLLS,
  },
  leaveForms: {
    name: 'leaveForms',
    gql: LEAVE_FORMS,
  },
  leaveFormCallAttempts: {
    name: 'leaveFormCallAttempts',
    gql: LEAVE_FORM_CALL_ATTEMPTS,
  },
  groupFiles: {
    name: 'groupFiles',
    gql: GROUP_FILES,
  },
  surveyCampaigns: {
    name: 'surveyCampaigns',
    gql: SURVEY_CAMPAIGNS,
  },
  surveyCampaign: {
    name: 'surveyCampaign',
    gql: SURVEY_CAMPAIGN,
  },
  surveyCampaignsCount: {
    name: 'surveyCampaignsCount',
    gql: SURVEY_CAMPAIGNS_COUNT,
  },
  surveyAudienceSummary: {
    name: 'surveyAudienceSummary',
    gql: SURVEY_AUDIENCE_SUMMARY,
  },
  surveyCampaignDispatches: {
    name: 'surveyCampaignDispatches',
    gql: SURVEY_CAMPAIGN_DISPATCHES,
  },
  surveyCampaignDispatchesCount: {
    name: 'surveyCampaignDispatchesCount',
    gql: SURVEY_CAMPAIGN_DISPATCHES_COUNT,
  },
  surveyTypes: {
    name: 'surveyTypes',
    gql: SURVEY_TYPES,
  },
};

// Check type maintaining inferred type
const checkTypeQuery = <Obj extends Record<string, IQuery>>(obj: Obj) => obj;
Query = checkTypeQuery(Query);

export { Query };
export * from './ProgramVariant';
